import ShiftTask from './ShiftTask';
export default ShiftTask;